import { IconName } from "src/shared/components/Icon";
import {
  HackPalBronzeBackground,
  HackPalGoldBackground,
  HackPalSilverBackground,
} from "src/static/img";
import { QuestType } from "src/views/goose-games/types";

interface Quest {
  headerIcon: IconName;
  color: string;
  backgroundColor: string;
}

export const medalProgression: Record<
  number,
  { title: string; description: string; emoji: string; background: string }
> = {
  50: {
    title: "Nestling",
    description: "Keep it up, 🥉Nestling!",
    emoji: "🥉",
    background: HackPalBronzeBackground,
  },
  150: {
    title: "Feather Collector",
    description: "You're on fire, 🥈Feather Collector!",
    emoji: "🥈",
    background: HackPalSilverBackground,
  },
  300: {
    title: "Golden Goose",
    description: "Absolutely killin' it, you 🥇Golden Goose!",
    emoji: "🥇",
    background: HackPalGoldBackground,
  },
};

export const MEDAL_PROGRESS_MAX = Math.max(
  ...Object.keys(medalProgression).map(Number)
);

export const QUESTS: Record<QuestType, Quest> = {
  SCANNED: {
    headerIcon: "qrcode",
    color: "#9344ED",
    backgroundColor: "#EADFF9",
  },
  QUESTION: {
    headerIcon: "chat",
    color: "#F99828",
    backgroundColor: "#FFFBEB",
  },
  ORGANIZER_APPROVED: {
    headerIcon: "gear",
    color: "#1AB3B0",
    backgroundColor: "#DFF9F4",
  },
  NETWORKING: {
    headerIcon: "network",
    color: "#DA3EC3",
    backgroundColor: "#FAE4FF",
  },
  BADGE: {
    headerIcon: "badge",
    color: "#3E55DA",
    backgroundColor: "#E6EAFF",
  },
};
